var map = {
	"./app.json": 416,
	"./blog.json": 417,
	"./components.json": 418,
	"./conversionTable.json": 419,
	"./currency.json": 420,
	"./currencyBRL.json": 421,
	"./currencyUSD.json": 422,
	"./cxi-old.json": 423,
	"./events.json": 424,
	"./form.json": 425,
	"./glossary.json": 426,
	"./home.json": 427,
	"./iframe.json": 428,
	"./login.json": 429,
	"./logout.json": 430,
	"./matches.json": 431,
	"./menu.json": 432,
	"./news.json": 433,
	"./notifications.json": 434,
	"./oiweek.json": 435,
	"./pages.json": 436,
	"./profile.json": 437,
	"./ranking-BKP.json": 438,
	"./ranking.json": 439,
	"./register.json": 440,
	"./startup.json": 441,
	"./startupId.json": 442,
	"./support.json": 443,
	"./translation.json": 444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;